export class FligthInspectionDataModel{
  altitude : number;
  gs_latitude : number;
  gs_longitude : number;
  measured_power_level : number;
  dme1_flux_dens : number;
  dme1_err_rng : number;
  dme2_flux_dens : number;
  dme2_err_rng : number;
  tac1_freq : number;
  tac1_err_rng : number;
  peak_level : number;

  // processing tool extra
  tac1_flux_dens : number;
  tac2_flux_dens : number;
  tac2_err_rng : number;
  power_density_flag : number;
  los_flag: number;
  prediction_flag : number;

  getInformation(){
    let information = "";

    information += '<h4 style="font-weight:bold">Flight Inspection</h4>';

    this.altitude != null ? information += "<p>Altitude: " + this.altitude + "</p>" : null;
    this.gs_latitude != null ? information += "<p>Ground Station Latitude: " + this.gs_latitude + "</p>" : null;
    this.gs_longitude != null ? information += "<p>Ground Station Longitude: " + this.gs_longitude + "</p>" : null;
    this.measured_power_level != null? information += "<p>Measured Power Level: " + this.measured_power_level + "</p>" : null;
    this.dme1_flux_dens != null? information += "<p>Dme1FluxDens: " + this.dme1_flux_dens + "</p>" : null;
    this.dme1_err_rng != null? information += "<p>Dme1ErrRng: " + this.dme1_err_rng + "</p>" : null;
    this.dme2_flux_dens != null? information += "<p>Dme2FluxDens: " + this.dme2_flux_dens + "</p>" : null;
    this.dme2_err_rng != null? information += "<p>Dme2ErrRng: " + this.dme2_err_rng + "</p>" : null;
    this.tac1_freq != null? information += "<p>Tac1Freq: " + this.tac1_freq + "</p>" : null;
    this.tac1_err_rng != null? information += "<p>Tac1ErrRng: " + this.tac1_err_rng + "</p>" : null;
    this.peak_level != null? information += "<p>PeakLevel: " + this.peak_level + "</p>" : null;

    return information;
  }

  getInformationForProcessingTool(){
    let information = "";

    information += '<h4 style="font-weight:bold">Processing Tool</h4>';

    this.gs_latitude != null ? information += "<p>A/C Latitude: " + this.gs_latitude + "</p>" : null;
    this.gs_longitude != null ? information += "<p>A/C Longitude: " + this.gs_longitude + "</p>" : null;
    this.altitude != null ? information += "<p>Altitude: " + this.altitude + "</p>" : null;
    this.dme1_err_rng != null? information += "<p>Dme1ErrRng: " + this.dme1_err_rng + "</p>" : null;
    this.dme2_err_rng != null? information += "<p>Dme2ErrRng: " + this.dme2_err_rng + "</p>" : null;
    this.tac1_err_rng != null? information += "<p>Tac1ErrRng: " + this.tac1_err_rng + "</p>" : null;
    this.tac2_err_rng != null? information += "<p>Tac2ErrRng: " + this.tac2_err_rng + "</p>" : null;
    this.measured_power_level != null? information += "<p>Measured Power Level: " + this.measured_power_level + "</p>" : null;
    this.dme1_flux_dens != null? information += "<p>Dme1FluxDens: " + this.dme1_flux_dens + "</p>" : null;
    this.dme2_flux_dens != null? information += "<p>Dme2FluxDens: " + this.dme2_flux_dens + "</p>" : null;
    this.tac1_flux_dens != null? information += "<p>Tac1FluxDens: " + this.tac1_flux_dens + "</p>" : null;
    this.tac2_flux_dens != null? information += "<p>Tac2luxDens: " + this.tac2_flux_dens + "</p>" : null;
    this.power_density_flag != null? information += "<p>Power Density Flag: " + this.power_density_flag + "</p>" : null;
    this.los_flag != null? information += "<p>LOS Flag: " + this.los_flag + "</p>" : null;
    this.prediction_flag != null? information += "<p>Prediction Flag: " + this.prediction_flag + "</p>" : null;
    this.peak_level != null? information += "<p>PeakLevel: " + this.peak_level + "</p>" : null;

    return information;
  }
}
